import LocalActivityIcon from "@mui/icons-material/LocalActivity"
import { Box, styled } from "@mui/material"
import Typography from "@mui/material/Typography"
import Convention from "models/convention-api/v1/Convention"
import ConventionRegistration from "models/convention-api/v1/ConventionRegistration"
import pluralize from "pluralize"
import React from "react"
import { pxToRem } from "utils/helpers"

interface TicketsCountProps {
  className?: string
  convention: Convention
  conventionRegistration: ConventionRegistration
}

const TicketsCount = (props: TicketsCountProps) => {
  const { className, convention, conventionRegistration } = props
  const peopleCount = conventionRegistration?.people_count
  if (typeof peopleCount !== "number") return <></>

  return (
    <_Container className={className}>
      <LocalActivityIcon color="inherit" />
      <Typography
        variant="paragraphRegular"
        aria-label={`You have ${pluralize("ticket", peopleCount)} registered for 
          ${convention.name}`}>
        {peopleCount}
      </Typography>
    </_Container>
  )
}

export default TicketsCount

const _Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexFlow: "row",
  gap: pxToRem(7),
}) as typeof Box
